import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_SUBSCRIPTION_STATE,
});

export const resetMessage = () => ({
  type: types.RESET_SUBSCRIPTION_MESSAGE,
});

export const createSubscription = (subscription) => ({
  type: types.CREATE_SUBSCRIPTION.REQUEST,
  subscription,
});

export const createSubscriptionSuccess = (subscription) => ({
  type: types.CREATE_SUBSCRIPTION.SUCCESS,
  subscription,
});

export const createSubscriptionFailure = (error) => ({
  type: types.CREATE_SUBSCRIPTION.FAILURE,
  error,
});

export const updateSubscription = (subscription) => ({
  type: types.UPDATE_SUBSCRIPTION.REQUEST,
  subscription,
});

export const updateSubscriptionSuccess = (subscription) => ({
  type: types.UPDATE_SUBSCRIPTION.SUCCESS,
  subscription,
});

export const updateSubscriptionFailure = (error) => ({
  type: types.UPDATE_SUBSCRIPTION.FAILURE,
  error,
});

export const cancelSubscription = (subscriptionId, userId) => ({
  type: types.CANCEL_SUBSCRIPTION.REQUEST,
  subscriptionId,
  userId,
});

export const cancelSubscriptionSuccess = (message, subscription) => ({
  type: types.CANCEL_SUBSCRIPTION.SUCCESS,
  message,
  subscription,
});

export const cancelSubscriptionFailure = (error) => ({
  type: types.CANCEL_SUBSCRIPTION.FAILURE,
  error,
});

export const fetchSubscriptions = (startDate, endDate) => ({
  type: types.FETCH_SUBSCRIPTIONS.REQUEST,
  startDate,
  endDate,
});

export const fetchSubscriptionsSuccess = (
  subscriptions,
  startDate,
  endDate,
) => ({
  type: types.FETCH_SUBSCRIPTIONS.SUCCESS,
  subscriptions,
  startDate,
  endDate,
});

export const fetchSubscriptionsFailure = (error) => ({
  type: types.FETCH_SUBSCRIPTIONS.FAILURE,
  error,
});

export const fetchSubscriptionsByUser = (userId) => ({
  type: types.FETCH_SUBSCRIPTIONS_BY_USER.REQUEST,
  userId,
});

export const fetchSubscriptionsByUserSuccess = (subscriptions) => ({
  type: types.FETCH_SUBSCRIPTIONS_BY_USER.SUCCESS,
  subscriptions,
});

export const fetchSubscriptionsByUserFailure = (error) => ({
  type: types.FETCH_SUBSCRIPTIONS_BY_USER.FAILURE,
  error,
});
